import AxiosControl from '../../context/axios/AxiosControl'
const Axios = AxiosControl()

export const getTicketsByClient = (client) => async (dispatch) => {
    dispatch({
        type: 'TICKET_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/ticket/getTicketsByClient/'+ client, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TICKET_GET_ALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'TICKET_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'TICKET_NOT_LOADING'
        })
    }
}

export const getTicketsByClub = (club) => async (dispatch) => {
    dispatch({
        type: 'TICKET_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/ticket/getTicketsByClub/'+ club, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TICKET_GET_ALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'TICKET_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'TICKET_NOT_LOADING'
        })
    }
}

export const getInvitationsByClub = (club) => async (dispatch) => {
    dispatch({
        type: 'TICKET_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/ticket/getInvitationsByClub/'+ club, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TICKET_GET_ALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'TICKET_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'TICKET_NOT_LOADING'
        })
    }
}

export const getTickets = () => async (dispatch) => {
    dispatch({
        type: 'TICKET_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/ticket/getAll', {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TICKET_GET_ALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'TICKET_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'TICKET_NOT_LOADING'
        })
    }
}

export const changeTicketStatus = (ticketId, userId, ticketStatus) => async (dispatch) => {
    dispatch({
        type: 'TICKET_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/ticket/changeStatus', {user: userId, ticket: ticketId, status: ticketStatus}, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TICKET_CHANGE_STATUS_SUCCESS',
                payload: data?.message
            })
        } else {
            dispatch({
                type: 'TICKET_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'TICKET_NOT_LOADING'
        })
    }
}

export const changeInvitationStatus = (invitationData, userId, invitationStatus) => async (dispatch) => {
    dispatch({
        type: 'TICKET_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/ticket/changeInvitationStatus', {user: userId, invitation: invitationData, status: invitationStatus}, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TICKET_CHANGE_STATUS_SUCCESS',
                payload: data?.message
            })
        } else {
            dispatch({
                type: 'TICKET_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'TICKET_NOT_LOADING'
        })
    }
}

export const getTicketsByInvitation = (invitationTemplate) => async (dispatch) => {
    dispatch({
        type: 'TICKET_INVITATION_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/ticket/getTicketsByInvitation/' + invitationTemplate, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TICKET_GET_INVITATION_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'TICKET_INVITATION_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'TICKET_INVITATION_NOT_LOADING'
        })
    }
}

export const getTicketsByPaymentClient = (client) => async (dispatch) => {
    dispatch({
        type: 'TICKET_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/ticket/getTicketsByPaymentClient/'+ client, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TICKET_GET_ALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'TICKET_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'TICKET_NOT_LOADING'
        })
    }
}

export const createInvitation = (invitationData) => async (dispatch) => {
    dispatch({
        type: 'TICKET_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/ticket/createInvitation', invitationData, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TICKET_CREATE_INVITATION_SUCCESS',
                payload: data?.message
            })
        } else {
            dispatch({
                type: 'TICKET_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'TICKET_NOT_LOADING'
        })
    }
}

export const createWindowTicket = (windowTicketData) => async (dispatch) => {    dispatch({
        type: 'TICKET_LOADING'
    })
    try {
        // Convertir maxUses a entero para asegurar el formato correcto
        const formattedData = {
            ...windowTicketData,
            maxUses: parseInt(windowTicketData.maxUses, 10) || 0,
            // Aplicar maxUses también a cada ticket si es necesario
            tickets: windowTicketData.tickets.map(ticket => ({
                ...ticket,
                maxUses: parseInt(windowTicketData.maxUses, 10) || 0
            }))
        };
        
        console.log("Datos a enviar a la API:", formattedData);
        
        const { data, status } = await Axios.post('/api/ticket/createWindowTicket', formattedData, {
            headers: { auth: sessionStorage.getItem('jwt') }
        });
        
        if (status === 200) {
            console.log("Respuesta del servidor:", data);
            dispatch({
                type: 'TICKET_CREATE_WINDOW_TICKET_SUCCESS',
                payload: data
            });
        } else {
            dispatch({
                type: 'TICKET_NOT_LOADING'
            });
        }
    } catch (error) {
        console.error("Error en createWindowTicket:", error);
        dispatch({
            type: 'TICKET_NOT_LOADING'
        });
    }
}

export const cancelAllActiveTicketsByClub = (clubId, userId) => async (dispatch) => {
    dispatch({
        type: 'TICKET_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/ticket/cancelAllActiveByClub/' + clubId, { user: userId }, {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TICKET_CANCEL_ALL_SUCCESS',
                payload: { message: data?.message, count: data?.count }
            })
        } else {
            dispatch({
                type: 'TICKET_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'TICKET_NOT_LOADING'
        })
    }
}